var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"feedback-container"},[_c('div',{staticClass:"feedback-box"},[_c('div',{staticClass:"title"},[_c('i',{staticClass:"fa fa-check-circle",attrs:{"aria-hidden":"true"}}),_c('h3',{staticClass:"survey-title"},[_vm._v("Thank you for your feedback!")])])])])
}]

export { render, staticRenderFns }